export const NAME_SPACE = 'LiveLine';
export const ROOT_STATE_KEY = 'liveline';
export const ROOT_SLICE_KEY = 'DateRangeFilter';
